import React from 'react';

import { Text, TextProps } from '@/components/ui/text';
import { useUser } from '@/hooks/use-data';

export const UserName: React.FC<{
	id: string,
	style?: TextProps['style'],
}> = ({ id, style }) => {
	const { data: user } = useUser(id);

	if (!user) {
		return null;
	}

	return (
		<Text style={style}>
			{user.name}
		</Text>
	);
};
